import UserCargoOfficerListRequest, {
  UserCargoOfficerListRequestStatusCriteria,
  UserCargoOfficerListRequestOrder,
} from "../../../../api/raily/user/cargo-officer/list/user-cargo-officer-list.request";
import UserOrder from "../../../../types/user-order";
import UserStatus from "../../../../types/user-status";
import paginationService from "../../../../utils/pagination/pagination.service";
import UserCargoOfficerListParams from "./user-cargo-officer-list-params";

const createStatusCriteria = (
  status: UserStatus | undefined,
): UserCargoOfficerListRequestStatusCriteria => {
  switch (status) {
    case UserStatus.ACTIVE:
      return UserCargoOfficerListRequestStatusCriteria.ACTIVE;
    case UserStatus.DELETED:
      return UserCargoOfficerListRequestStatusCriteria.DELETED;
    default:
      return UserCargoOfficerListRequestStatusCriteria.ALL;
  }
};

const createOrder = (
  status: UserOrder | undefined,
): UserCargoOfficerListRequestOrder | undefined => {
  switch (status) {
    case UserOrder.FIRST_NAME_ASC:
      return UserCargoOfficerListRequestOrder.FIRST_NAME_ASC;
    case UserOrder.FIRST_NAME_DESC:
      return UserCargoOfficerListRequestOrder.FIRST_NAME_DESC;
    case UserOrder.LAST_NAME_ASC:
      return UserCargoOfficerListRequestOrder.LAST_NAME_ASC;
    case UserOrder.LAST_NAME_DESC:
      return UserCargoOfficerListRequestOrder.LAST_NAME_DESC;
    case UserOrder.USERNAME_ASC:
      return UserCargoOfficerListRequestOrder.USERNAME_ASC;
    case UserOrder.USERNAME_DESC:
      return UserCargoOfficerListRequestOrder.USERNAME_DESC;
    default:
      return undefined;
  }
};

const create = (
  params: UserCargoOfficerListParams,
): UserCargoOfficerListRequest => {
  return {
    cargoCompany: params.cargoCompany,
    cargoCompanyId: params.cargoCompanyId,
    email: params.email,
    firstName: params.firstName,
    lastName: params.lastName,
    offset: paginationService.calculateOffset(params.page, params.pageSize),
    order: createOrder(params.order),
    statusCriteria: createStatusCriteria(params.status),
    username: params.username,
    creationEnd: params.creationEnd,
    creationStart: params.creationStart,
    limit: params.pageSize,
  };
};

const userCargoOfficerListParamsFactory = { create };

export default userCargoOfficerListParamsFactory;
